import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody } from '../../../Shared/Brand'
import { PageHeader, TabBar, TableWrap, EmptyState } from '../../../Shared/DashboardUI'

function IncomeOverview() {
  const [activeTab, setActiveTab] = useState('arbitrage')
  return (
    <>
      <PageHeader title="Income Overview" />

      <div className="xdb-card" style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '14px' }}>
          <div>
            <div style={{ fontSize: '13px', color: C.ltx2, marginBottom: '6px' }}>Total Balance</div>
            <div style={{ fontSize: '30px', fontWeight: 700, color: C.ltx, fontFamily: fOutfit }}>0.00 <span style={{ fontSize: '14px', color: C.ltx3, fontFamily: fBody }}>USDT</span></div>
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button className="xdb-btn">Buy Crypto</button>
            <Link to="/user/withdrawal" className="xdb-btn" style={{ textDecoration: 'none', background: 'transparent', border: `1px solid ${C.dbdr}`, color: C.ltx2 }}>Withdraw</Link>
            <button className="xdb-btn" style={{ background: 'transparent', border: `1px solid ${C.dbdr}`, color: C.ltx2 }}>Transfer</button>
          </div>
        </div>
      </div>

      <div className="xdb-card">
        <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '12px', fontFamily: fBody }}>Wallet Activity</h5>
        <TabBar
          tabs={[
            { key: 'arbitrage', label: 'Arbitrage Income' },
            { key: 'referral', label: 'Referral Income' },
            { key: 'spread', label: 'Spread Income' },
          ]}
          active={activeTab}
          onChange={setActiveTab}
        />
        {activeTab === 'arbitrage' && (
          <TableWrap>
            <thead>
              <tr><th>Sr No.</th><th>Date/Time</th><th>Amount</th><th>Income Type</th><th>Email</th><th>Invoice</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>06-14-24 10:35:42</td>
                <td>Spot</td>
                <td style={{ color: C.primary }}>315.50 USDT</td>
                <td>Withdraw</td>
                <td>txn-9871dfcd-45</td>
                <td>315.50 USDT</td>
              </tr>
            </tbody>
          </TableWrap>
        )}
        {activeTab === 'referral' && (
          <TableWrap>
            <thead>
              <tr><th>Sr No.</th><th>Date/Time</th><th>Amount</th><th>Tier</th><th>Income Type</th><th>Email</th><th>Invoice ID</th></tr>
            </thead>
            <tbody>
              <tr><td colSpan="7"><EmptyState message="No records" /></td></tr>
            </tbody>
          </TableWrap>
        )}
        {activeTab === 'spread' && (
          <TableWrap>
            <thead>
              <tr><th>Sr No.</th><th>Date/Time</th><th>Amount</th><th>Tier</th><th>Income Type</th><th>Email</th><th>Invoice ID</th></tr>
            </thead>
            <tbody>
              <tr><td colSpan="7"><EmptyState message="No records" /></td></tr>
            </tbody>
          </TableWrap>
        )}
      </div>
    </>
  )
}

export default IncomeOverview
